import { Box } from "@mui/material";

export default function Shop() {
    return (
    <Box sx={{ m:"auto", maxWidth:"300px", p:"20px", }}>
        Kommt noch
    </Box>
    );
}